import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperVotePlazaPage } from './shopper-vote-plaza';

@NgModule({
  declarations: [
    ShopperVotePlazaPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperVotePlazaPage),
    TranslateModule.forChild()
  ],
})
export class ShopperVotePlazaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-vote-plaza/shopper-vote-plaza.module.ts